import type {MailerDataService} from 'shared/mailer';
import type {FinishedResponseInteractionService} from 'shared/services';
import type {ExactUserRawBodyMailSendRequest, RawBodyMailSendRequest} from 'src/typings';

export class MailerService {
    public static serviceName = 'mailerService';

    /*@ngInject*/
    constructor(private mailerDataService: MailerDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    public async sendMailToExactUsers(request: ExactUserRawBodyMailSendRequest): Promise<void> {
        try {
            const actionResponse = await this.mailerDataService.sendMailToExactUsers(request);
            return this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            throw exceptionResponse;
        }
    }

    public async sendMail(request: RawBodyMailSendRequest): Promise<void> {
        try {
            const actionResponse = await this.mailerDataService.sendMail(request);
            return this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            throw exceptionResponse;
        }
    }
}
